// @flow
import classify from '@src/utils/typestyle';
import DynamicBase from './DynamicBase';

import { ObjectType } from '@types/misc';

type TProps = {
  className?: string,
  style?: ObjectType,
  minWidth?: number | string,
  maxWidth?: number | string,
  hideCloseButton?: boolean,
  doNotScrollToPopup?: boolean,
  preferSideAttachment?: boolean,
  initialContent: {
    Header?: string,
    Content: Node
  }
};

type PopupPropsType = {
  show: boolean,
  onCloseClick: () => void,
  anchorElement?: HTMLElement | null
};

type ContainerPropsType = {
  children: React.Node
};

type ContainerStateType = {
  showPopup: boolean
};

export default class LinkPopup extends React.Component<
  TProps,
  ContainerStateType
> {
  linkRef: void | React.ElementRef<'a'>;

  state = {
    showPopup: false
  };

  showPopup = (e: SyntheticMouseEvent<HTMLSpanElement | HTMLImageElement>) => {
    e.preventDefault();
    if (!this.state.showPopup) this.setState({ showPopup: true });
  };

  handleKeyPress = (
    e: SyntheticKeyboardEvent<HTMLSpanElement | HTMLImageElement>
  ) => {
    if (e.key == 'Enter') {
      this.setState({ showPopup: !this.state.showPopup });
    }
  };

  handleBlur = () => {
    if (this.state.showPopup) {
      this.setState({ showPopup: false });
    }
  };

  closePopup = () => {
    this.setState({ showPopup: false });
  };

  render() {
    return (
      <span>
        <span
          onClick={this.showPopup}
          onKeyPress={this.handleKeyPress}
          // onBlur={this.handleBlur}
          className={this.props.className}
          style={{ cursor: 'pointer', ...this.props.style }}
          ref={ref => {
            this.linkRef = ref || undefined;
          }}
          role='button'
          tabIndex={0}
        >
          {this.props.children}
        </span>
        <DynamicBase
          {...this.props}
          show={this.state.showPopup}
          onCloseClick={this.closePopup}
          anchorElement={this.linkRef}
        />
      </span>
    );
  }
}

LinkPopup.defaultProps = {
  className: 'text-link text-underline',
  style: {}
};
